import { styled } from "goober";
import { forwardRef } from "react";
import { INPUT_BUTTONS_WIDTH } from "./InputContainer";

const Container = styled("div")`
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  textarea {
    field-sizing: content;
    padding: 12px;
    background-color: var(--surface-primary);
    color: var(--text-primary);
    box-shadow: var(--elevation-low);
    border: 0;
    outline: 0.5px solid var(--border-alpha);
    border-radius: 12px;
    font-size: 12px;
    font-family: InterVariable;
    line-height: 16px;
    padding-right: ${INPUT_BUTTONS_WIDTH}px;
    resize: none;
    width: 100%;
    transition: box-shadow 100ms ease-out;
    &::placeholder {
      color: var(--text-primary);
      opacity: 0.3;
    }
  }
  .right {
    position: absolute;
    right: 8px;
    bottom: 8px;
    display: flex;
    gap: 4px;
    align-items: center;
  }
`;

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  right?: React.ReactNode;
  minRows?: number;
  maxRows?: number;
}

// line-height (16px) + vertical padding (12px × 2) are defined in Container above
const rowsToHeight = (rows: number) => rows * 16 + 24;

export const Textarea = forwardRef<HTMLTextAreaElement, Props>(
  ({ right, minRows, maxRows, style, ...props }, ref) => {
    return (
      <Container>
        <textarea
          {...props}
          ref={ref}
          style={{
            ...(minRows != null && { minHeight: rowsToHeight(minRows) }),
            ...(maxRows != null && {
              maxHeight: rowsToHeight(maxRows),
              overflowY: "auto" as const,
            }),
            ...style,
          }}
        />
        {right && <div className="right">{right}</div>}
      </Container>
    );
  }
);
